/**
 * 收银台
 */
export default {
  // 项目收银台
  projectInfoselectProjectCategoryList: "/projectInfo/selectProjectCategoryList", //  门店服务收银台分类
  projectInfoselectProjectInfoList: "/projectInfo/selectProjectInfoList", //  项目列表
  projectInfoselectProjectPackageList: "/projectInfo/selectProjectPackageList", // 套餐列表
  cashier_orderselect_project_order: "/cashier_order/select_project_order", // 查询项目订单
  cashier_orderproject_save_order: "/cashier_order/project_save_order", // 项目订单开单
  cashier_orderproject_pay_order: "/cashier_order/project_pay_order", // 项目订单支付
  cashier_orderverification_appointment: "/cashier_order/verification_appointment", // 核销预约订单
  cashier_orderwechat_code_pay_order: "/cashier_order/wechat_code_pay_order", // 微信付款码支付（项目）
  cashier_orderselect_pay_order: "/cashier_order/select_pay_order", // 主动查询订单支付状态（项目）

  // 商品收银台
  productCategoryshopProductCategoryList: "/productCategory/shopProductCategoryList", // 门店商品收银台分类
  productInfoselectProductList: "/productInfo/selectProductListBank", // 商品列表
  cashier_orderselect_product_info: "/cashier_order/select_product_info", // 查询商品订单
  cashier_orderproduct_save_order: "/cashier_order/product_save_order", // 商品订单开单
  cashier_orderproduct_pay_order: "/cashier_order/product_pay_order", // 商品订单支付
  cashier_orderpayment_code_pay_product_order: "/cashier_order/payment_code_pay_product_order", //付款码微信支付(商品支付)

  cashier_orderhuifuReversePay: "/cashier_order/huifuReversePay", // 汇付收银台支付 (新！)

  cashier_orderselect_pay_product_order: "/cashier_order/select_pay_product_order", // 主动查询订单支付状态(商品支付)
  product_QRCode_pay_order: "/cashier_order/product_QRCode_pay_order", // 收银台商品订单二维码支付
  project_QRCode_pay_order: "/cashier_order/project_QRCode_pay_order", // 收银台项目订单支付二维码支付

  // 取消
  cashier_orderbank_cancel_order: "/cashier_order/bank_cancel_order", // 取消商品订单 / 取消项目订单
  cashier_orderwechat_code_cancel_product_order: "/cashier_order/wechat_code_cancel_product_order", // 微信付款码取消订单(商品支付)

  // 会员
  memberInfopageList: "/memberInfo/pageList", // 会员列表
  memberInfomemberPurchasedPageList: "/memberInfo/memberPurchasedPageList", // 会员已购项目列表
  memberInfoinsert: "/memberInfo/insert", // 新增会员
  memberInfoaddServiceCount: "/memberInfo/addServiceCount", // 增加服务次数

  // 员工
  // cashier_orderchoice_technician: "/cashier_order/choice_technician", // 核验后选择技师
  store_project_reservation: "/store_project_reservation/choice_technician", // 核验后选择技师
  employeeInfoselectEmployee: "/employeeInfo/selectEmployee", // 收银台选择员工
  departmentInfoselectParentDepartment: "/departmentInfo/selectParentDepartment", // 查询上级部门下拉框
}
